import Operation from './Operation';

export default class Subtraction extends Operation {
  cal (a, b) {
    if (a === null || a === undefined) {
      // CAUTION:
      // in Grasshopper,
      // null - (num) = (num)
      return Number(b);
    }
    a = Number(a);
    b = Number(b);
    return a - b;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Subtraction.js